import PropTypes from 'prop-types';
import pick from 'lodash/pick';

import config from '@plone/volto/registry';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { Image } from 'semantic-ui-react';

import { resolveHomepageImage } from '../../../helpers/homepageUtils';
import { resolveRichTextHtml } from '../../../helpers/richTextHtml';

const CARD_ALLOWED_BLOCKS = ['csjCard'];

const LegacyIconCardGridBody = ({ data }) => {
  const items = data?.items || [];

  if (!items.length) {
    return null;
  }

  return (
    <div className="icon-card-grid icon-card-grid--legacy">
      {items.map((item, index) => {
        const imageSrc = resolveHomepageImage(item.icon);
        const imageAlt =
          (typeof item.icon === 'object' &&
            !Array.isArray(item.icon) &&
            item.icon?.title) ||
          item.title ||
          '';

        return (
          <div
            className="icon-card-row"
            key={`${item.title || 'item'}-${index}`}
          >
            <div className="icon-card-icon">
              {imageSrc ? (
                <Image src={imageSrc} alt={imageAlt} />
              ) : (
                <div className="icon-card-icon-placeholder" />
              )}
            </div>
            <div className="icon-card-content">
              {item.title ? (
                <h5 className="icon-card-title">{item.title}</h5>
              ) : null}
              {item.description ? (
                <div
                  className="icon-card-description"
                  dangerouslySetInnerHTML={{
                    __html: resolveRichTextHtml(item.description),
                  }}
                />
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};

LegacyIconCardGridBody.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

const IconCardGridBody = ({ data, path, metadata }) => {
  const layoutItems = data?.blocks_layout?.items || [];

  if (layoutItems.length) {
    const blocksConfig = pick(config.blocks.blocksConfig, CARD_ALLOWED_BLOCKS);

    return (
      <div className="icon-card-grid">
        <RenderBlocks
          content={{
            blocks: data.blocks || {},
            blocks_layout: data.blocks_layout || { items: [] },
          }}
          path={path}
          metadata={metadata}
          blocksConfig={blocksConfig}
        />
      </div>
    );
  }

  return <LegacyIconCardGridBody data={data} />;
};

IconCardGridBody.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  path: PropTypes.string,
  metadata: PropTypes.objectOf(PropTypes.any),
};

export default IconCardGridBody;
